// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"p4-z","dimensionLabel":"q4-z","styleChooserControlWrapper":"r4-z","styleChooserControl":"s4-z","disabled":"t4-z","giftCard":"u4-z","styleChooserText":"v4-z"};